import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useFontAccessibility } from '../context/FontAccessibilityContext';
import { Menu, ChevronDown, X, Type } from 'lucide-react';

import ScreenReaderButton from './ScreenReaderButton';
import API_BASE_URL from '../services/apiconfig';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [departmentsDropdown, setDepartmentsDropdown] = useState(false);
  const [citizenCornerDropdown, setCitizenCornerDropdown] = useState(false);
  const [galleryDropdown, setGalleryDropdown] = useState(false);
  const [informationDropdown, setInformationDropdown] = useState(false);
const [registerDropdown, setRegisterDropdown] = useState(false);


  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();
  const { fontSize, increaseFontSize, decreaseFontSize, resetFontSize } = useFontAccessibility();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [bankingMobile, setBankingMobile] = useState(false);
  const [consumerCoopMobile, setConsumerCoopMobile] = useState(false);
  const [creditMobile, setCreditMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const institutionsRef = useRef(null);
  const servicesRef = useRef(null);

  const registerRef = useRef(null);

  const content = {
    en: {
      home: 'Home',
      about: 'About Us',
      institutions: 'Institutions',
      policy: 'Policy',
      services: 'Services',
      schemes: 'Schemes',
      register: 'eRCS',
login: 'Login',
screenReader: 'Screen Reader',
fontSize: 'Font Size',
shopProducts: 'Our Products',
availableProducts: 'Available Products',
contactUs: 'Contact Us',

      // Register submenu
      newSociety: 'Register New Society',
      existingSociety: 'Migrate Existing Society',

      
      // Institutions submenu
      consumerCooperatives: 'Consumer Cooperatives',
      banking: 'Banking',
      creditSocieties: 'Credit Societies',
      agriMarketing: 'Agri Marketing',
      dccws: 'DCCWS',
      primaryStores: 'Primary Stores',
      tnsacb: 'TNSACB',
      dccb: 'DCCB',
      ucb: 'UCB',
      paccs: 'PACCS',
      lamps: 'LAMPS',
      uccs: 'UCCS',
      pcardb: 'PCARDB',
      ecs: 'ECS',
      cms: 'CMS',
      
      // Policy submenu
      actsRules: 'Acts & Rules',
      gos: 'GOs',
      circulars: 'Circulars',
      
      // Services submenu
      ekcc: 'e-KCC',
      evadagai: 'eVadagai',
      marunthagam: 'Marunthagam',
      pds: 'PDS',
      quickCommerce: 'Quick Commerce',
      societyRegistration: 'Society Registration',
      
      // Schemes submenu
      kcc: 'KCC',
      loanMechanisation: 'Loan Mechanisation',
      autoProvision: 'Auto Provision',
      womenLand: 'Women Land',
      thayumanavar: 'Thaayumaanavar',

      cropLoanWaiver: 'Crop Loan Waiver 2026',

      // Mobile menu
      menu: 'Menu',
      reset: 'Reset'
    },
    ta: {
      home: 'முகப்பு',
      about: 'எங்களைப் பற்றி',
      institutions: 'நிறுவனங்கள்',
      policy: 'கொள்கை',
      services: 'சேவைகள்',
      schemes: 'திட்டங்கள்',
      register: 'eRCS',
login: 'உள்நுழைவு',
screenReader: 'திரை வாசிப்பு',
fontSize: 'எழுத்துரு',
shopProducts: 'எங்கள் தயாரிப்புகள்',
availableProducts: 'கிடைக்கும் தயாரிப்புகள்',
contactUs: 'தொடர்பு கொள்ளுங்கள்',

      // Register submenu
      newSociety: 'புதிய சங்கம் பதிவு',
      existingSociety: 'இருக்கும் சங்கம் இடம்பெயர்வு',

      
      // Institutions submenu
      consumerCooperatives: 'நுகர்வோர் கூட்டுறவு',
      banking: 'வங்கி',
      creditSocieties: 'கடன் சங்கங்கள்',
      agriMarketing: 'விவசாய சந்தைப்படுத்தல்',
      dccws: 'DCCWS',
      primaryStores: 'முதன்மை கடைகள்',
      tnsacb: 'TNSACB',
      dccb: 'DCCB',
      ucb: 'UCB',
      paccs: 'PACCS',
      lamps: 'LAMPS',
      uccs: 'UCCS',
      pcardb: 'PCARDB',
      ecs: 'ECS',
      cms: 'CMS',
      
      // Policy submenu
      actsRules: 'சட்டங்கள் மற்றும் விதிகள்',
      gos: 'அரசாணைகள்',
      circulars: 'சுற்றறிக்கைகள்',
      
      // Services submenu
      ekcc: 'இ-கேசிசி',
      evadagai: 'இ-வாடகை',
      marunthagam: 'மருந்தகம்',
      pds: 'PDS',
      quickCommerce: 'விரைவு வர்த்தகம்',
      societyRegistration: 'சங்க பதிவு',
      
      // Schemes submenu
      kcc: 'கேசிசி',
      loanMechanisation: 'கடன் இயந்திரமயமாக்கல்',
      autoProvision: 'ஆட்டோ வழங்கல்',
      womenLand: 'பெண்கள் நிலம்',
      thayumanavar: 'தாயுமானவர்',

      cropLoanWaiver: 'பயிர் கடன் தள்ளுபடி 2026',

      // Mobile menu
      menu: 'பட்டியல்',
      reset: 'மீட்டமை'
    }
  };

  const t = content[language];

  const handleLanguageToggle = () => {
    const newLanguage = language === 'en' ? 'ta' : 'en';
    localStorage.setItem('preferredLanguage', newLanguage);
    toggleLanguage();
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage && savedLanguage !== language) {
      toggleLanguage();
    }
  }, []);

  const closeAllDropdowns = () => {
    setDepartmentsDropdown(false);
    setCitizenCornerDropdown(false);
    setGalleryDropdown(false);
    setInformationDropdown(false);
    setRegisterDropdown(false);
    setBankingMobile(false);
    setConsumerCoopMobile(false);
    setCreditMobile(false);
  };

  const handleMobileMenuToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
    if (isOpen) {
      closeAllDropdowns();
    }
  };

  const handleMenuItemClick = () => {
    setIsOpen(false);
    closeAllDropdowns();
  };

  const handleDropdownClick = (dropdownType, e) => {
    e.preventDefault();
    e.stopPropagation();

    switch (dropdownType) {
      case 'departments':
        setDepartmentsDropdown(!departmentsDropdown);
        setCitizenCornerDropdown(false);
        setGalleryDropdown(false);
        setInformationDropdown(false);
        setRegisterDropdown(false);
        break;
      case 'citizenCorner':
        setCitizenCornerDropdown(!citizenCornerDropdown);
        setDepartmentsDropdown(false);
        setGalleryDropdown(false);
        setInformationDropdown(false);
        setRegisterDropdown(false);
        break;
      case 'gallery':
        setGalleryDropdown(!galleryDropdown);
        setDepartmentsDropdown(false);
        setCitizenCornerDropdown(false);
        setInformationDropdown(false);
        setRegisterDropdown(false);
        break;
      case 'information':
        setInformationDropdown(!informationDropdown);
        setDepartmentsDropdown(false);
        setCitizenCornerDropdown(false);
        setGalleryDropdown(false);
        setRegisterDropdown(false);
        break;
      case 'register':
        setRegisterDropdown(!registerDropdown);
        setDepartmentsDropdown(false);
        setCitizenCornerDropdown(false);
        setGalleryDropdown(false);
        setInformationDropdown(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const mobileMenu = document.querySelector('.mobile-menu-container');
      const mobileToggle = document.querySelector('.mobile-toggle');

      if (isOpen && mobileMenu && !mobileMenu.contains(event.target) && !mobileToggle.contains(event.target)) {
        setIsOpen(false);
        closeAllDropdowns();
      }
    };

    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(false);
    closeAllDropdowns();
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
  institutionsRef.current && !institutionsRef.current.contains(event.target) &&
servicesRef.current && !servicesRef.current.contains(event.target) &&
registerRef.current && !registerRef.current.contains(event.target)
      ) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="w-full top-0 left-0 z-50">
      <div className="sr-only">
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <a href="#navigation" className="skip-link">Skip to navigation</a>
      </div>

      <div className="bg-white border-b border-gray-200 w-full relative z-[60]">
        <div className="w-full px-2 py-1 sm:py-2 lg:py-3 flex items-center justify-between">
          <div className="flex-shrink-0">
            <img
              src="/Images/cooplogo.png"
              alt="Cooperative Logo"
              className="h-7 w-7 sm:h-10 sm:w-10 lg:h-16 lg:w-16 rounded-full bg-white"
              style={{
                boxShadow: `inset 2px 2px 4px rgba(255, 255, 255, 0.8), inset -2px -2px 4px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.15)`
              }}
            />
          </div>

          <div className="flex-1 flex flex-col items-center text-center px-1 lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2">
            <div className="hidden lg:flex lg:flex-col lg:items-center">
              <h2 className="text-gray-700 font-bold leading-tight text-[27px]">
                கூட்டுறவுத் துறை
              </h2>
              <h1 className="text-[#D32F2F] font-semibold mt-1 leading-tight text-[23px] tracking-tight">
                Department of Cooperation
              </h1>
            </div>
          </div>

          <div className="flex items-center gap-1.5 sm:gap-3 flex-shrink-0">
            <div className="hidden lg:flex items-center gap-2">
              <button
                onClick={decreaseFontSize}
                className="h-9 w-9 flex items-center justify-center border-2 border-[#1976D2] text-[#1976D2] bg-white rounded text-sm font-bold hover:bg-[#E3F2FD] transition-colors cursor-pointer"
                aria-label="Decrease font size"
              >
                A−
              </button>

              <button
                onClick={increaseFontSize}
                className="h-9 w-9 flex items-center justify-center border-2 border-[#1976D2] text-[#1976D2] bg-white rounded text-sm font-bold hover:bg-[#E3F2FD] transition-colors cursor-pointer"
                aria-label="Increase font size"
              >
                A+
              </button>

              <button
                onClick={resetFontSize}
                className="h-9 w-9 flex items-center justify-center border-2 border-[#1976D2] text-[#1976D2] bg-white rounded hover:bg-[#E3F2FD] transition-colors cursor-pointer"
                aria-label="Reset font size"
              >
                <Type size={16} />
              </button>

              {/* Screen Reader Button */}
              <ScreenReaderButton />

              <div className="flex items-center gap-0 border-2 border-[#1976D2] rounded overflow-hidden">
                <button
                  onClick={handleLanguageToggle}
                  className={`h-9 px-3 flex items-center justify-center text-sm font-semibold transition-colors cursor-pointer border-r-2 border-[#1976D2] ${language === 'en' ? 'bg-[#1976D2] text-white' : 'bg-white text-[#1976D2] hover:bg-[#E3F2FD]'}`}
                  aria-label="Switch to English"
                >
                  En
                </button>

                <button
                  onClick={handleLanguageToggle}
                  className={`h-9 px-3 flex items-center justify-center text-sm font-semibold transition-colors cursor-pointer ${language === 'ta' ? 'bg-[#1976D2] text-white' : 'bg-white text-[#1976D2] hover:bg-[#E3F2FD]'}`}
                  aria-label="Switch to Tamil"
                >
                  த
                </button>
              </div>
            </div>

            <div className="lg:hidden flex items-center gap-0 border-2 border-[#1976D2] rounded overflow-hidden">
              <button
                onClick={handleLanguageToggle}
                className={`h-7 px-2 flex items-center justify-center text-xs font-semibold transition-colors cursor-pointer border-r-2 border-[#1976D2] ${language === 'en' ? 'bg-[#1976D2] text-white' : 'bg-white text-[#1976D2] hover:bg-[#E3F2FD]'}`}
                aria-label="Switch to English"
              >
                En
              </button>

              <button
                onClick={handleLanguageToggle}
                className={`h-7 px-2 flex items-center justify-center text-xs font-semibold transition-colors cursor-pointer ${language === 'ta' ? 'bg-[#1976D2] text-white' : 'bg-white text-[#1976D2] hover:bg-[#E3F2FD]'}`}
                aria-label="Switch to Tamil"
              >
                த
              </button>
            </div>

            <button
              className="lg:hidden mobile-toggle p-1 rounded-md text-[#1976D2] border-2 border-[#1976D2]"
              onClick={handleMobileMenuToggle}
            >
              {isOpen ? <X size={18} /> : <Menu size={18} />}
            </button>

            <div className="flex-shrink-0">
              <div
                className="h-7 w-7 sm:h-10 sm:w-10 lg:h-16 lg:w-16 rounded-full bg-white flex items-center justify-center"
                style={{
                  boxShadow: `inset 1.5px 1.5px 3px rgba(255,255,255,0.9), inset -1.5px -1.5px 3px rgba(255,255,255,0.6), 0 6px 14px rgba(0,0,0,0.2)`
                }}
              >
                <img
                  src="/Images/tn-logo.png"
                  alt="Tamil Nadu Logo"
                  className="h-full w-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="navigation" className={`hidden lg:block bg-gradient-to-r from-[#005A8D] via-[#006AA5] to-[#005A8D] text-white w-full shadow-md transition-all duration-300 ${isScrolled ? 'fixed top-0 left-0 z-50' : ''} -mb-5`}>
        <div className="w-full px-4 sm:px-4 lg:px-8 py-3">
          <div className="flex items-center justify-center w-full mx-auto">
            <nav className="hidden lg:flex items-center justify-center w-full" role="navigation" aria-label="Main navigation">
              <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 font-medium whitespace-nowrap">
                <li>
                  <Link
                    to="/"
                    className={`px-3 py-2 rounded-md transition-all duration-200 text-base ${location.pathname === '/' ? 'bg-white bg-opacity-20 text-white font-semibold' : 'hover:bg-white hover:bg-opacity-10'}`}
                    aria-current={location.pathname === '/' ? 'page' : undefined}
                  >
                    {t.home}
                  </Link>
                </li>

                <li>
                  <Link
                    to="/about-us"
                    className="px-3 py-2 rounded-md hover:bg-white hover:bg-opacity-10 transition-all duration-200 text-base"
                  >
                    {t.about}
                  </Link>
                </li>

                <li
                  className="relative group"
                  ref={institutionsRef}
                  onClick={() => isMobile ? setActiveDropdown(activeDropdown === "institutions" ? null : "institutions") : null}
                  onMouseEnter={!isMobile ? () => setActiveDropdown("institutions") : undefined}
                  onMouseLeave={!isMobile ? () => setActiveDropdown(null) : undefined}
                >
                  <button className="px-3 py-2 rounded-md hover:bg-white hover:bg-opacity-10 transition-all duration-200 flex items-center">
                    <span className="text-base font-medium">{t.institutions}</span>
                    <svg
                      className={`ml-1 w-4 h-4 transform transition-transform duration-200 ${activeDropdown === "institutions" ? "rotate-180" : ""}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {activeDropdown === "institutions" && (
                    <ul className="absolute left-0 bg-white shadow-lg rounded-md mt-0 w-60 z-50 text-black">
                      {/* Banking - B */}
                      <li className="relative group/bank">
                        <button className="w-full text-left px-4 py-2 hover:bg-gray-100 flex justify-between items-center">
                          {t.banking}
                          <ChevronDown size={16} className="ml-2 transition-transform group-hover/bank:rotate-180" />
                        </button>

                        <ul className="absolute left-full top-0 bg-white shadow-lg rounded-md w-56 text-black opacity-0 invisible group-hover/bank:opacity-100 group-hover/bank:visible transition-all duration-200">
                          <li>
                            <Link to="/dccwss" className="block px-4 py-2 hover:bg-gray-100">{t.dccb}</Link>
                          </li>
                          <li>
                            <Link to="/tnsc" className="block px-4 py-2 hover:bg-gray-100">{t.tnsacb}</Link>
                          </li>
                          <li>
                            <Link to="/ucb" className="block px-4 py-2 hover:bg-gray-100">{t.ucb}</Link>
                          </li>
                        </ul>
                      </li>

                      {/* Consumer Cooperatives - C */}
                      <li className="relative group/coop">
                        <button className="w-full text-left px-4 py-2 hover:bg-gray-100 flex justify-between items-center">
                          {t.consumerCooperatives}
                          <ChevronDown size={16} className="ml-2 transition-transform group-hover/coop:rotate-180" />
                        </button>

                        <ul className="absolute left-full top-0 bg-white shadow-lg rounded-md w-56 text-black opacity-0 invisible group-hover/coop:opacity-100 group-hover/coop:visible transition-all duration-200">
                          <li>
                            <Link to="/dccws" className="block px-4 py-2 hover:bg-gray-100">{t.dccws}</Link>
                          </li>
                          <li>
                            <Link to="/dccws#primary-section" className="block px-4 py-2 hover:bg-gray-100">{t.primaryStores}</Link>
                          </li>
                        </ul>
                      </li>

                      {/* Credit Societies - C */}
                      <li className="relative group/credit">
                        <button className="w-full text-left px-4 py-2 hover:bg-gray-100 flex justify-between items-center">
                          {t.creditSocieties}
                          <ChevronDown size={16} className="ml-2 transition-transform group-hover/credit:rotate-180" />
                        </button>

                        <ul className="absolute left-full top-0 bg-white shadow-lg rounded-md w-56 text-black opacity-0 invisible group-hover/credit:opacity-100 group-hover/credit:visible transition-all duration-200">
                          <li>
                            <Link to="/ecs" className="block px-4 py-2 hover:bg-gray-100">{t.ecs}</Link>
                          </li>
                          <li>
                            <Link to="/lamps" className="block px-4 py-2 hover:bg-gray-100">{t.lamps}</Link>
                          </li>
                          <li>
                            <Link to="/paccs" className="block px-4 py-2 hover:bg-gray-100">{t.paccs}</Link>
                          </li>
                          <li>
                            <Link to="/pcardb" className="block px-4 py-2 hover:bg-gray-100">{t.pcardb}</Link>
                          </li>
                          <li>
                            <Link to="/uccs" className="block px-4 py-2 hover:bg-gray-100">{t.uccs}</Link>
                          </li>
                        </ul>
                      </li>

                      {/* CMS - C */}
                      <li>
                        <Link to="/agri-marketing" className="block px-4 py-2 hover:bg-gray-100">{t.cms}</Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li>
                  <Link
                    to="/policy/acts-and-rules"
                    className="px-3 py-2 rounded-md hover:bg-white hover:bg-opacity-10 transition-all duration-200 text-base"
                  >
                    {t.policy}
                  </Link>
                </li>

                <li
                  className="relative"
                  ref={servicesRef}
                  onMouseEnter={() => setActiveDropdown("services")}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <button className="px-3 py-2 rounded-md hover:bg-white hover:bg-opacity-10 transition-all duration-200 flex items-center">
                    <span className="text-base font-medium">{t.services}</span>
                    <svg
                      className={`ml-1 w-4 h-4 transform transition-transform duration-200 ${activeDropdown === "services" ? "rotate-180" : ""}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {activeDropdown === "services" && (
                    <ul className="absolute left-0 bg-white shadow-lg rounded-md mt-0 w-64 z-50 text-black">
                      <li>
                        <a
                          href="https://www.tnesevai.tn.gov.in/Citizen/PortalLogin.aspx"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          {t.ekcc}
                        </a>
                      </li>
                      <li>
                        <Link to="/services/evadagai" className="block px-4 py-2 hover:bg-gray-100">{t.evadagai}</Link>
                      </li>
                      <li>
                        <Link to="/services/marunthagam" className="block px-4 py-2 hover:bg-gray-100">{t.marunthagam}</Link>
                      </li>
                      <li>
                        <Link to="/services/pds" className="block px-4 py-2 hover:bg-gray-100">{t.pds}</Link>
                      </li>
                      <li>
                        <Link to="/quick-commerce" className="block px-4 py-2 hover:bg-gray-100">{t.quickCommerce}</Link>
                      </li>
                      <li>
                        <Link to="/society-registration" className="block px-4 py-2 hover:bg-gray-100">{t.societyRegistration}</Link>
                      </li>
                    </ul>
                  )}
                </li>



                <li
                  className="relative"
                  ref={registerRef}
                  onMouseEnter={() => setActiveDropdown("register")}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <button className="px-3 py-2 rounded-md hover:bg-white hover:bg-opacity-10 transition-all duration-200 flex items-center">
                    <span className="text-base font-medium">{t.register}</span>
                    <svg
                      className={`ml-1 w-4 h-4 transform transition-transform duration-200 ${activeDropdown === "register" ? "rotate-180" : ""}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {activeDropdown === "register" && (
                    <ul className="absolute left-0 bg-white shadow-lg rounded-md mt-0 w-72 z-50 text-black">
                      <li>
                        <a
                          href="https://ercs.kooturavu.tn.gov.in/register?reset=1&type=new"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          {t.newSociety}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://ercs.kooturavu.tn.gov.in/register?reset=1&type=existing"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block px-4 py-2 hover:bg-gray-100"
                        >
                          {t.existingSociety}
                        </a>
                      </li>
                    </ul>
                  )}
                </li>
<li>
<Link
  to="/our-products"
  className="px-3 py-2 rounded-md hover:bg-white hover:bg-opacity-10 transition-all duration-200 text-base text-yellow-300 hover:text-yellow-200 font-semibold"
>
  {t.shopProducts}
</Link>
</li>
<li>
<Link
  to="/crop-loan-waiver-2026"
  className="crop-loan-btn px-3 py-2 rounded-md text-base font-semibold hover:bg-white hover:bg-opacity-10 transition-colors"
>
  {t.cropLoanWaiver}
  <span className="new-badge">New</span>
</Link>
</li>
<li>
<Link
  to="/contact-us"
  className="px-3 py-2 rounded-md hover:bg-white hover:bg-opacity-10 transition-all duration-200 text-base"
>
  {t.contactUs || 'Contact Us'}
</Link>
</li>
<li>
  <Link to="/login-portal" className="px-3 py-2 rounded-md hover:bg-white hover:bg-opacity-10 transition-all duration-200 text-base">
    {t.login}
  </Link>
</li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {isOpen && (
        <>
          <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setIsOpen(false)} aria-hidden="true"></div>

          <div className="mobile-menu-container lg:hidden fixed top-0 left-0 bg-white shadow-2xl z-50 w-80 h-screen overflow-y-auto" role="dialog" aria-modal="true">
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-4 flex justify-between items-center sticky top-0 z-50">
              <h2 className="font-bold text-lg">{t.menu}</h2>
              <button onClick={() => setIsOpen(false)} className="text-white p-1" type="button" aria-label="Close menu">
                <X size={24} />
              </button>
            </div>

            <div className="p-0 pt-20">
              <Link
                to="/"
                className={`block py-3 px-4 border-b border-gray-100 ${location.pathname === '/' ? 'bg-blue-50 text-blue-700 font-semibold' : 'text-gray-700'} hover:bg-gray-50`}
                onClick={handleMenuItemClick}
              >
                {t.home}
              </Link>

              <Link
                to="/about-us"
                className="block py-3 px-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50"
                onClick={handleMenuItemClick}
              >
                {t.about}
              </Link>

              <div className="border-b border-gray-100">
                <div
                  className="flex items-center justify-between py-3 px-4 text-gray-700 hover:bg-gray-50 cursor-pointer"
                  onClick={(e) => handleDropdownClick('departments', e)}
                >
                  <span>{t.institutions}</span>
                  <ChevronDown size={16} className={`transition-transform duration-200 ${departmentsDropdown ? 'rotate-180' : ''}`} />
                </div>
                <div className={`bg-gray-50 overflow-hidden transition-all duration-200 ${departmentsDropdown ? 'max-h-[800px]' : 'max-h-0'}`}>
                  
                  {/* Banking - B */}
                  <div className="border-b border-gray-200">
                    <div
                      className="flex items-center justify-between py-2.5 px-8 text-sm text-gray-700 hover:bg-blue-50 cursor-pointer"
                      onClick={() => setBankingMobile(!bankingMobile)}
                    >
                      <span>{t.banking}</span>
                      <ChevronDown size={14} className={`transition-transform ${bankingMobile ? 'rotate-180' : ''}`} />
                    </div>
                    <div className={`overflow-hidden transition-all duration-200 ${bankingMobile ? 'max-h-60' : 'max-h-0'}`}>
                      <Link to="/dccwss" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.dccb}</Link>
                      <Link to="/tnsc" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.tnsacb}</Link>
                      <Link to="/ucb" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.ucb}</Link>
                    </div>
                  </div>

                  {/* Consumer Cooperatives - C */}
                  <div className="border-b border-gray-200">
                    <div className="flex items-center justify-between py-2.5 px-8 text-sm text-gray-700 hover:bg-blue-50 cursor-pointer"
                      onClick={() => setConsumerCoopMobile(prev => !prev)}>
                      <span>{t.consumerCooperatives}</span>
                      <ChevronDown size={14} className={`${consumerCoopMobile ? "rotate-180" : ""} transition-transform`} />
                    </div>
                    <div className={`overflow-hidden transition-all duration-200 ${consumerCoopMobile ? "max-h-60" : "max-h-0"}`}>
                      <Link to="/dccws" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.dccws}</Link>
                      <Link to="/dccws#primary-section" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.primaryStores}</Link>
                    </div>
                  </div>

                  {/* Credit Societies - C */}
                  <div className="border-b border-gray-200">
                    <div
                      className="flex items-center justify-between py-2.5 px-8 text-sm text-gray-700 hover:bg-blue-50 cursor-pointer"
                      onClick={() => setCreditMobile(!creditMobile)}
                    >
                      <span>{t.creditSocieties}</span>
                      <ChevronDown size={14} className={`transition-transform ${creditMobile ? 'rotate-180' : ''}`} />
                    </div>
                    <div className={`overflow-hidden transition-all duration-200 ${creditMobile ? 'max-h-80' : 'max-h-0'}`}>
                      <Link to="/ecs" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.ecs}</Link>
                      <Link to="/lamps" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.lamps}</Link>
                      <Link to="/paccs" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.paccs}</Link>
                      <Link to="/pcardb" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.pcardb}</Link>
                      <Link to="/uccs" className="block py-2 px-12 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.uccs}</Link>
                    </div>
                  </div>

                  {/* CMS - C */}
                  <div className="border-b border-gray-200">
                    <Link to="/agri-marketing" className="block py-2.5 px-8 text-sm text-gray-700 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.cms}</Link>
                  </div>

                </div>
              </div>

              <Link
                to="/policy/acts-and-rules"
                className="block py-3 px-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50"
                onClick={handleMenuItemClick}
              >
                {t.policy}
              </Link>

              <div className="border-b border-gray-100">
                <div
                  className="flex items-center justify-between py-3 px-4 text-gray-700 hover:bg-gray-50 cursor-pointer"
                  onClick={(e) => handleDropdownClick('gallery', e)}
                >
                  <span>{t.services}</span>
                  <ChevronDown size={16} className={`transition-transform duration-200 ${galleryDropdown ? 'rotate-180' : ''}`} />
                </div>
                <div className={`bg-gray-50 overflow-hidden transition-all duration-200 ${galleryDropdown ? 'max-h-[500px]' : 'max-h-0'}`}>
                  <a 
                    href="https://www.tnesevai.tn.gov.in/Citizen/PortalLogin.aspx" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200"
                    onClick={handleMenuItemClick}
                  >
                    {t.ekcc}
                  </a>
                  <Link to="/services/evadagai" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200" onClick={handleMenuItemClick}>{t.evadagai}</Link>
                  <Link to="/services/marunthagam" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200" onClick={handleMenuItemClick}>{t.marunthagam}</Link>
                  <Link to="/services/pds" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200" onClick={handleMenuItemClick}>{t.pds}</Link>
                  <Link to="/quick-commerce" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200" onClick={handleMenuItemClick}>{t.quickCommerce}</Link>
                  <Link to="/society-registration" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.societyRegistration}</Link>
                </div>
              </div>

         <div className="border-b border-gray-100">
  <div
    className="flex items-center justify-between py-3 px-4 text-gray-700 hover:bg-gray-50 cursor-pointer"
    onClick={(e) => handleDropdownClick('citizenCorner', e)}
  >
    <span>{t.schemes}</span>
    <ChevronDown size={16} className={`transition-transform duration-200 ${citizenCornerDropdown ? 'rotate-180' : ''}`} />
  </div>
  <div className={`bg-gray-50 overflow-hidden transition-all duration-200 ${citizenCornerDropdown ? 'max-h-80' : 'max-h-0'}`}>
    <Link to="/auto" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200" onClick={handleMenuItemClick}>{t.autoProvision}</Link>
    <Link to="/kcc" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200" onClick={handleMenuItemClick}>{t.kcc}</Link>
    <Link to="/loan" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200" onClick={handleMenuItemClick}>{t.loanMechanisation}</Link>
    <Link to="/thayumanavar" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200" onClick={handleMenuItemClick}>{t.thayumanavar}</Link>
    <Link to="/schemes/women-land" className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50" onClick={handleMenuItemClick}>{t.womenLand}</Link>
  </div>
</div>
              <div className="border-b border-gray-100">
                <div
                  className="flex items-center justify-between py-3 px-4 text-gray-700 hover:bg-gray-50 cursor-pointer"
                  onClick={(e) => handleDropdownClick('register', e)}
                >
                  <span>{t.register}</span>
                  <ChevronDown size={16} className={`transition-transform duration-200 ${registerDropdown ? 'rotate-180' : ''}`} />
                </div>
                <div className={`bg-gray-50 overflow-hidden transition-all duration-200 ${registerDropdown ? 'max-h-60' : 'max-h-0'}`}>
                  <a
                    href="https://ercs.kooturavu.tn.gov.in/register?reset=1&type=new"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50 border-b border-gray-200"
                    onClick={handleMenuItemClick}
                  >
                    {t.newSociety}
                  </a>
                  <a
                    href="https://ercs.kooturavu.tn.gov.in/register?reset=1&type=existing"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block py-2.5 px-8 text-sm text-gray-600 hover:bg-blue-50"
                    onClick={handleMenuItemClick}
                  >
                    {t.existingSociety}
                  </a>
                </div>
              </div>
<Link
  to="/login-portal"
  className="block py-3 px-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50"
  onClick={handleMenuItemClick}
>
  {t.login}
</Link>
<Link
  to="/our-products"
  className="block py-3 px-4 text-orange-600 font-bold border-b border-gray-100 hover:bg-orange-50 flex items-center gap-2"
  onClick={handleMenuItemClick}
>
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
  {t.shopProducts}
</Link>
<Link
  to="/crop-loan-waiver-2026"
  className="crop-loan-btn-mobile py-3 px-4 text-gray-700 font-semibold border-b border-gray-100 hover:bg-gray-50"
  onClick={handleMenuItemClick}
>
  {t.cropLoanWaiver}
  <span className="new-badge">New</span>
</Link>
<Link
  to="/contact-us"
  className="block py-3 px-4 text-gray-700 border-b border-gray-100 hover:bg-gray-50"
  onClick={handleMenuItemClick}
>
  {t.contactUs || 'Contact Us'}
</Link>

              <div className="border-b border-gray-100 p-4">
                <div className="text-gray-700 font-medium mb-3 text-sm">{t.fontSize}</div>
                <div className="flex items-center gap-3">
                  <button
                    onClick={decreaseFontSize}
                    className="flex-1 py-2.5 px-4 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors text-center font-bold"
                    aria-label="Decrease Font Size"
                  >
                    A-
                  </button>
                  <button
                    onClick={increaseFontSize}
                    className="flex-1 py-2.5 px-4 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors text-center font-bold"
                    aria-label="Increase Font Size"
                  >
                    A+
                  </button>
                  <button
                    onClick={resetFontSize}
                    className="flex-1 py-2.5 px-4 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors text-center font-semibold text-sm"
                    aria-label="Reset Font Size"
                  >
                    {t.reset}
                  </button>
                </div>
              </div>

              <div className="border-b border-gray-100 p-4">
                <div className="text-gray-700 font-medium mb-3 text-sm">{t.screenReader}</div>
                <ScreenReaderButton />
              </div>
            </div>
          </div>
        </>
      )}

    </header>
  );
};

export default Navbar;